import {
  Component,
  Input,
  OnInit,
  OnChanges,
  ViewChild,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  SessionLibService,
  TerminalDataModel,
} from '@nutricontrol/app360-shared';
import { ReportsService } from '../../reports.service';
import { TranslationsLibService } from '@nutricontrol/app360-shared';
import { IonModal } from '@ionic/angular';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SimpleChanges } from '@angular/core';
import {
  CurrencyDataModel,
  TerminalCurrencyDataModel,
} from '../../reports.model';

@Component({
  selector: 'app-terminal-configuration-form',
  templateUrl: './terminal-configuration-form.component.html',
  styleUrls: ['./terminal-configuration-form.component.scss'],
})
export class TerminalConfigurationFormComponent implements OnInit, OnChanges {
  @Input() terminal: TerminalDataModel;
  @Output() terminalCurrency = new EventEmitter<TerminalCurrencyDataModel>();
  @ViewChild(IonModal) modal: IonModal;
  terminalForm: FormGroup;
  initialCurrency: string | null = null;
  currencies: CurrencyDataModel[];
  isDirty = false;

  constructor(
    public translationLib: TranslationsLibService,
    private reportsService: ReportsService,
    private sessionLibService: SessionLibService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    this.terminalForm = this.fb.group({
      currency: [null, Validators.required],
    });

    this.terminalForm.valueChanges.subscribe(() => {
      const currentCurrency = this.terminalForm.get('currency')?.value;
      this.isDirty = currentCurrency !== this.initialCurrency;
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.terminal) {
      this.terminalConfig();
    }
  }

  terminalConfig() {
    if (!this.terminal) {
      return;
    }
    this.reportsService.getEnabledCurrencies().subscribe({
      next: (currencies) => (this.currencies = currencies),
      error: (error) => {
        console.error('Error al obtener las monedas disponibles', error);
      },
    });
    this.reportsService.getTerminalCurrency(this.terminal.vid).subscribe({
      next: (terminalCurrency) => {
        const currencyCode = terminalCurrency.currency.code;
        this.initialCurrency = currencyCode;
        this.terminalForm.patchValue({
          currency: currencyCode,
        });
        this.isDirty = false;
      },
      error: (error) => {
        console.error('Error al obtener el tipo de moneda del equipo', error);
      },
    });
  }

  onSubmit() {
    if (this.terminalForm.valid) {
      this.reportsService
        .setTerminalCurrency(this.terminal.vid, {
          code: this.terminalForm.get('currency')?.value,
        })
        .subscribe({
          next: (terminalCurrency) => {
            this.terminalCurrency.emit(terminalCurrency);
            this.initialCurrency = this.terminalForm.get('currency')?.value;
            this.isDirty = false;
          },
          error: (error) => {
            console.error('Error al guardar la moneda del equipo:', error);
          },
        });
    }
  }

  currencyName(currency: CurrencyDataModel): string {
    let name = currency.name;

    if (typeof name === 'string') {
      try {
        name = JSON.parse(name);
      } catch (error) {
        return currency.identifier;
      }
    }

    const locale = this.sessionLibService.getLanguage();
    if (name.hasOwnProperty(locale)) {
      return name[locale];
    }
    if (name.hasOwnProperty('en')) {
      return name.en;
    }

    return currency.identifier;
  }
}
